import { render, staticRenderFns } from "./QuizFileUploadForm.vue?vue&type=template&id=4928d00e&"
import script from "./QuizFileUploadForm.vue?vue&type=script&lang=ts&"
export * from "./QuizFileUploadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports